import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import { DropzoneArea } from 'material-ui-dropzone'
import Button from '../Button'

const useStyles = createUseStyles(
  {
    'drop-zone': { margin: 0, padding: '8px', display: 'none', width: '100%' },
    'upload-btn': {
      marginLeft: '10px'
    },
    container: {
      spacing: 1,
      direction: 'row'
    }
  },
  { name: 'bund-' }
)

export const DropZone = (props) => {
  const {
    name,
    id,
    className,
    style,
    onClick,
    onChange,
    onFileUpload,
    chipProps,
    type,
    button,
    fileType,
    variant,
    shape,
    size,
    color,
    buttonType,
    maxFileSize,
    filesLimit,
    acceptedFiles,
    ...rest
  } = props
  const classes = useStyles()
  return (
    <div
      className={clsx('text-color margin42', classes['drop-zone'], className)}
      style={style}
      id="upload-image-form"
      {...rest}>
      <DropzoneArea
        maxFileSize={500000000}
        filesLimit={filesLimit}
        showPreviews
        acceptedFiles={[acceptedFiles]}
        showPreviewsInDropzone={false}
        useChipsForPreview
        previewGridProps={{ container: classes.container }}
        previewChipProps={
          chipProps
            ? {
                classes: {
                  root: chipProps
                }
              }
            : { classes: {} }
        }
        inputProps={{
          name: name,
          id: id,
          type: 'file'
        }}
        previewText="Selected file"
        onDrop={onChange}
        onAdd={onChange}
        onChange={onChange}
      />
      <br />
      {button && onFileUpload ? (
        <Button
          className={clsx(classes['upload-btn'], className)}
          color={color}
          variant={variant}
          shape={shape}
          size={size}
          onClick={onFileUpload}
          type={buttonType}>
          {type === 'upload' ? 'Upload ' : 'Update '} {fileType}
        </Button>
      ) : (
        ''
      )}
    </div>
  )
}

DropZone.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,

  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  chipProps: PropTypes.object,
  type: PropTypes.oneOfType([
    PropTypes.oneOf(['upload', 'update']),
    PropTypes.string
  ]),

  name: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onFileUpload: PropTypes.func,
  fileType: PropTypes.string,
  variant: PropTypes.string,
  shape: PropTypes.string,
  size: PropTypes.string,
  buttonType: PropTypes.string,
  color: PropTypes.string,
  filesLimit: PropTypes.number,
  acceptedFiles: PropTypes.string
}

DropZone.defaultProps = {
  type: 'upload',
  fileType: 'Image',
  variant: 'outline',
  shape: 'round',
  size: 'sm',
  buttonType: 'submit',
  color: 'primary',
  filesLimit: 1,
  acceptedFiles: 'image/*'
}

DropZone.displayName = 'dz'

export default DropZone
